import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TransactionResult } from "src/app/core/services/interfaces/transaction-result";

@Injectable({
	providedIn: 'root',
})
export class PromiseCallerService {
    public CallMethodAsPromise<T>(
		serviceObject: any,
		methodName: string,
		...args: any[]): Promise<TransactionResult<T>> {
		return new Promise((resolve, reject) => {
			methodName = methodName.trim();
	
			const method = serviceObject[methodName];
	
			if (typeof method !== 'function') {
				reject(new Error(`Method ${methodName} is not a function`));
				return;
			}
	
			const methodResult = method.call(serviceObject, ...args);
	
			if (methodResult instanceof Observable) {
				// If the method returns an Observable, subscribe to it
				methodResult.subscribe(
					(result: TransactionResult<T>) => {
						if (!result.success) {
							reject(result);
							return;
						}
						resolve(result);
					},
					(error) => {
						reject(error);
					}
				);
			} else if (methodResult instanceof Promise) {
				// If the method returns a Promise, wait for it to resolve
				methodResult.then(
					(result: TransactionResult<T>) => {
						if (!result.success) {
							reject(result);
							return;
						}
						resolve(result);
					},
					(error) => {
						reject(error);
					}
				);
			} else {
				// If the method returns a value directly, resolve with it
				resolve(methodResult);
			}
		});
	}
}